class LoaderCtrl {
  noteIsSplit = false;
  note0 = "";
  note1 = "";

  constructor() {}
  
  $onInit() {
    this.noteIsSplit = this.note && this.note.split(' ').length > 1;
    if(this.noteIsSplit) [this.note0, this.note1] = this.note.split(' ');
  }
}

export default {
  bindings: {note: '<'},
  templateUrl: 'layout/loader/loader.component.html',
  controller: LoaderCtrl
}